import * as dialogHelper from 'infrastructure/js/components/Dialog/dialogHelper';
import Network from 'infrastructure/js/modules/network';
import {api as messageDialogApi} from '../../MessageDialog/messageDialogActions';

/////////////////////////////////////////////////////////////////////
// ACTION TYPES - PUBLIC, FOR REDUCERS
export const actionTypes = {
  COMMON_DIALOG_SHOW: 'COMMON_DIALOG_SHOW',
  COMMON_DIALOG_HIDE: 'COMMON_DIALOG_HIDE',
  COMMON_DIALOG_FETCH_DIALOG_DATA_READY: 'COMMON_DIALOG_FETCH_DIALOG_DATA_READY',
  COMMON_DIALOG_SET_BUSY: 'COMMON_DIALOG_SET_BUSY',

  COMMON_DIALOG_SET_VALIDATION_WARNINGS_DATA: 'COMMON_DIALOG_SET_VALIDATION_WARNINGS_DATA',
  COMMON_DIALOG_HIDE_IGNORE_VALIDATION_WARNINGS_CHECKBOX: 'COMMON_DIALOG_HIDE_IGNORE_VALIDATION_WARNINGS_CHECKBOX',
  COMMON_DIALOG_TOGGLE_IGNORE_VALIDATION_WARNINGS_CHECKBOX: 'COMMON_DIALOG_TOGGLE_IGNORE_VALIDATION_WARNINGS_CHECKBOX',

};

/////////////////////////////////////////////////////////////////////
// PLAIN ACTION CREATORS - PRIVATE, FOR LOCAL DISPATCH ONLY
function getActions() {
    return actions;
  }

 const actions = {
    show: function (payload) {
      return {type: actionTypes.COMMON_DIALOG_SHOW, payload: payload};
    },
    hide: function (payload) {
      return {type: actionTypes.COMMON_DIALOG_HIDE, payload: payload};
    },
    fetchDialogDataReady(payload) {
      return {type: actionTypes.COMMON_DIALOG_FETCH_DIALOG_DATA_READY, payload: payload};
    },
    setBusy(payload) {
      return {type: actionTypes.COMMON_DIALOG_SET_BUSY, payload: payload};
    },
   setValidationWarningsData(payload) {
     return { type: actionTypes.COMMON_DIALOG_SET_VALIDATION_WARNINGS_DATA, payload: payload };
   },
   hideIgnoreValidationWarningsCheckbox() {
     return { type: actionTypes.COMMON_DIALOG_HIDE_IGNORE_VALIDATION_WARNINGS_CHECKBOX };
   },
   toggleIgnoreValidationWarningsCheckbox(payload) {
     return { type: actionTypes.COMMON_DIALOG_TOGGLE_IGNORE_VALIDATION_WARNINGS_CHECKBOX, payload: payload };
   },
}

/////////////////////////////////////////////////////////////////////
// METHODS FOR JSX PROPS - PUBLIC, ALL THUNK TYPE

function getJsxActions(api) {
  return {
    show(data) {
      return function (dispatch, getState) {
        api.show(dispatch, getState)(data);
      };
    },

    hide() {
      return function (dispatch, getState) {
        api.hide(dispatch, getState)();
      };
    },

    submit(data, messageDialogBuilder, reloadParentComponent, submitConfigData = null) {
      return function (dispatch, getState) {
        return api.submit(dispatch, getState)(data, messageDialogBuilder, reloadParentComponent, submitConfigData);
      };
    },

    // fetchDialogData(fetchConfig, callback) {
    //   return function (dispatch, getState) {
    //     api.fetchDialogData(dispatch, getState)(fetchConfig, callback, true);
    //   };
    // },

    hideIgnoreValidationWarningsCheckbox() {
      return function (dispatch, getState) {
        api.hideIgnoreValidationWarningsCheckbox(dispatch, getState)();
      };
    },

    toggleIgnoreValidationWarningsCheckbox(value) {
      return function (dispatch, getState) {
        api.toggleIgnoreValidationWarningsCheckbox(dispatch, getState)(value);
      };
    },
  };
}

/////////////////////////////////////////////////////////////////////
// API METHODS - PUBLIC, FOR OTHER ACTION MODULES (and internal use)

function getApiActions(actions, config) {
  if (config.getSubmitMethod === undefined || typeof config.getSubmitMethod !== 'function') {
    console.error('commonDialogActions: config.getSubmitMethod error: ', config.getSubmitMethod);
    return {};
  }

  return {
    show(dispatch, getState) {
      return function (data = null) {
        if (this.fetchDialogData) {
          return this.fetchDialogData(dispatch, getState)().then(() => {
            dispatch(actions.show(data));
          });
        }
        dispatch(actions.show(data));
      }.bind(this);
    },

    hide(dispatch) {
      return function () {
        dispatch(actions.hide());
      };
    },

    submit(dispatch, getState) {
      return function (data, messageDialogBuilder, reloadParentComponent, submitConfigData = null) {
        dispatch(actions.setBusy(true));

        return config
          .getSubmitMethod(submitConfigData)(data)
          .then((response) => {
            dispatch(actions.setBusy(false));

            let validations = dialogHelper.getResponseValidationDetails(response);
            if (validations) {
              dispatch(actions.setValidationWarningsData(validations));
              return response; //TODO: L test it!
            }

            dispatch(actions.hide());

            if (!Network.isResponseValid(response)) {
              console.error(config.getSubmitMethod(submitConfigData).name + ' failed ', response);
              messageDialogApi.responseError(dispatch, getState)(response);
              return response; //TODO: L test it!
            }

            if (reloadParentComponent) {
              reloadParentComponent();
            }

            if (messageDialogBuilder) {
              let messageDialogDescriptor = messageDialogBuilder(...this.getMessageDialogBuilderData(dispatch, getState)(response, data));
              messageDialogApi.open(dispatch, getState)(messageDialogDescriptor);
            }
            return response;
          })
          .catch((error) => {
            console.error('commonDialogActions: submit failed, catch error: ', error);
            dispatch(actions.setBusy(false));
            dispatch(actions.hide());
          });
      }.bind(this);
    },

    getMessageDialogBuilderData(dispatch, getState) {
      return function (response) {
        return [response.data, messageDialogApi.close(dispatch, getState)];
      };
    },

    hideIgnoreValidationWarningsCheckbox(dispatch) {
      return function () {
        dispatch(actions.hideIgnoreValidationWarningsCheckbox());
      };
    },

    toggleIgnoreValidationWarningsCheckbox(dispatch) {
      return function (value) {
        dispatch(actions.toggleIgnoreValidationWarningsCheckbox(value));
      };
    },
  };
}


export const createDialogActions = ({
                                     config,
                                     actionOverrides = {},
                                     apiOverrides = {},
                                     jsxOverrides = {},
                                   }) => {

  const baseActions = getActions();
  const actions = {
    ...baseActions,
    ...actionOverrides,
  };

  const baseApi = getApiActions(actions, config);
  const api = {
    ...baseApi,
    ...apiOverrides,
  };

  const baseJsx = getJsxActions(api);
  const jsxActions = {
    ...baseJsx,
    ...jsxOverrides,
  };

  return {
    actionTypes,
    actions,
    api,
    jsxActions,
  };
};







